/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { useBackgroundStyle } from '../../utils/styles/background'
import { useDisplayStyle } from '../../utils/styles/display'
import { useMarginStyle } from '../../utils/styles/margin'
import { usePaddingStyle } from '../../utils/styles/padding'
import { usePositionStyle } from '../../utils/styles/position'
import { useSizeStyle } from '../../utils/styles/size'

const Position = ({ type, children, ...props }) => {
  const style = css`
    ${usePositionStyle({ position: type, zIndex: 100, ...props })}
    ${useBackgroundStyle(props)}
    ${usePaddingStyle(props)}
    ${useMarginStyle(props)}
    ${useSizeStyle(props)}
    ${useDisplayStyle(props)}
  `

  return (
    <div className="position" css={style} {...props}>
      {children}
    </div>
  )
}

export const Relative = props => <Position type="relative" {...props} />
export const Absolute = props => <Position type="absolute" {...props} />
export const Fixed = props => <Position type="fixed" {...props} />

export default Position
